export default __webpack_public_path__ + "static/media/origins_of_the_rivalry_3.e4debc93.png";